module.exports = __webpack_public_path__ + "static/img/wallet-bg.d08d80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/wallet-bg.png
// module id = 5ZR+
// module chunks = 1